<template>
  <!-- Geometrie + Typo 1:1 live (.referenz-uebersicht #cat-nav, gemessen 1440/1024):
       Zellen large-8/large-11 offset-1 (8.333% + 10px Zellpadding), Strich
       hr.stroke 55x3 mit 30px Abstand, Hauptliste ul.topics.semi-large
       (26px rubrik-regular, Zeilenhöhe 3rem, 20px Abstand), Nebenliste
       ul.topics.grey (Body-Größe, lowercase, #999), Reset rechts (semi-large).
       Trenner "/" und Aktiv-Zustand: .wg-topics in der Site-CSS. -->
  <div ref="rootEl" class="project-filter -mt-[5px] font-base md:ml-[calc(8.333%+10px)] md:mr-2.5">
    <span class="mb-[30px] block h-[3px] w-[55px] rounded-sm bg-accent-1" aria-hidden="true"></span>
    <!-- live h1.h2.large > strong: rubrik-medium 22/30/32px, lh 1.4, ls .6px -->
    <p class="mb-5 text-[22px] font-medium leading-[1.4] tracking-[0.6px] text-accent-1 min-[480px]:text-[30px] md:text-[32px]">Filter mich:</p>

    <ul v-if="categories.length" class="wg-topics mb-5 text-[20px] leading-[3rem] min-[480px]:text-[26px]">
      <li v-for="c in categories" :key="'m-' + c" :class="{ active: active === c }">
        <button type="button" @click="setFilter(c)">{{ c }}</button>
      </li>
    </ul>

    <ul v-if="tags.length" class="wg-topics wg-topics-grey mb-0 lowercase leading-[1.6] text-[#999]">
      <li v-for="t in tags" :key="'s-' + t" :class="{ active: active === t }">
        <button type="button" @click="setFilter(t)">{{ t }}</button>
      </li>
    </ul>

    <div class="text-right">
      <button
        type="button"
        class="pr-[15px] text-[20px] font-extralight leading-[1.4] text-default min-[480px]:text-[26px]"
        @click="reset"
      >
        <span class="font-bold text-accent-1" aria-hidden="true">X</span> Alle anzeigen
      </button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { layoutMosaic } from '../mosaic.js'

// Liest Kategorien/Tags aus den server-gerenderten Kacheln, baut die Filterleiste
// und blendet nicht passende Kacheln per `hidden` aus — das CSS-Grid packt dank
// grid-auto-flow:dense selbst um. Zusätzlich wird grid-auto-rows auf die
// Spaltenbreite gesetzt, damit die Kacheln quadratisch tessellieren.
export default {
  name: 'ProjectFilter',
  setup() {
    const rootEl = ref(null)
    const categories = ref([])
    const tags = ref([])
    const active = ref(null)

    let gridEl = null
    let tiles = []

    const splitAttr = (value) =>
      (value || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)

    const collect = (root) => {
      tiles = Array.from(root.querySelectorAll('[data-project-item]'))
      const cats = new Set()
      const tg = new Set()
      tiles.forEach((tile) => {
        splitAttr(tile.getAttribute('data-categories')).forEach((c) => cats.add(c))
        splitAttr(tile.getAttribute('data-tags')).forEach((t) => tg.add(t))
      })
      // Wie live: beide Reihen alphabetisch.
      categories.value = Array.from(cats).sort((a, b) => a.localeCompare(b, 'de'))
      tags.value = Array.from(tg).sort((a, b) => a.localeCompare(b, 'de'))
    }

    const apply = () => {
      const label = active.value
      tiles.forEach((tile) => {
        const labels = [
          ...splitAttr(tile.getAttribute('data-categories')),
          ...splitAttr(tile.getAttribute('data-tags')),
        ]
        const show = !label || labels.includes(label)
        tile.style.display = show ? '' : 'none'
      })
      // Sichtbare Kacheln neu packen (Masonry respektiert display:none).
      layoutMosaic(gridEl)
    }

    const setFilter = (label) => {
      active.value = active.value === label ? null : label
      apply()
    }

    const reset = () => {
      active.value = null
      apply()
    }

    // Live verlinkt gefilterte Übersichten als /referenzen?k=<slug>, z.B.
    // ?k=corporate_design aus dem Leistungs-Modul. Die Slugs sind webEdition-
    // Kategorien und decken sich nicht zeichengenau mit unseren Labels
    // ("webdesign" vs. "Webdesign & Programmierung"), deshalb wird auf beiden
    // Seiten auf Kleinbuchstaben ohne Sonderzeichen normalisiert und der
    // Präfix verglichen.
    const normalize = (value) => (value || '').toLowerCase().replace(/[^a-z0-9]/g, '')

    const applyFilterFromUrl = () => {
      const wanted = new URLSearchParams(window.location.search).get('k')
      if (!wanted) return
      const needle = normalize(wanted)
      if (!needle) return
      const match = [...categories.value, ...tags.value].find(
        (label) => normalize(label).startsWith(needle)
      )
      if (match) {
        active.value = match
        apply()
      }
    }

    onMounted(() => {
      const root = rootEl.value && rootEl.value.closest('[data-project-grid]')
      if (!root) return
      gridEl = root.querySelector('[data-project-grid-items]')
      collect(root)
      applyFilterFromUrl()
      // Masonry-Layout + Resize-Neupacken erledigt der globale Enhancer
      // (initProjectMosaics); hier nur initial sicherstellen.
      layoutMosaic(gridEl)
    })

    return { rootEl, categories, tags, active, setFilter, reset }
  },
}
</script>
